import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './style.css';
import T from 'i18n-react';
import LoadingSpinner from '../Loading/loadingSpinner';
import { connect } from 'react-redux';
import AuthorizeCRAMyAccount_EN from '../../resources/MyAccountAuthorization_CRA_English.pdf';
import AuthorizeCRAMyAccount_FR from '../../resources/MyAccountAuthorization_CRA_French.pdf';
import OpenLinkInNewTabIcon from '../../images/OpenLinkInNewTab.svg';
import CopyContentIcon from '../../images/content_copy.svg';

const AuthorizeMyAccountCRA = (props) => {
    const [checked, setChecked] = useState(false);
    const [copyText, setCopyText] = useState('Authorize.MyAccount.Copy');
    const [copyClicked, setCopyClicked] = useState(false);
    const [hoverCopy, setHoverCopy] = useState(false);

    useEffect(() => {
        if (props.craBusinessNumber == null) {
            props.loadAuthorizationConfig();
        }
        
        if (props.onAuthorizationComplete) {
            props.onAuthorizationComplete(checked);
        }
    }, [props.craBusinessNumber, checked]);

    const jumpToMessage = () => {
        if (props.onJumpToMessages) {
            props.onJumpToMessages();
        }
    };

    const onLinkClick = () => {
        if (props.craLinkClicked) {
            props.craLinkClicked(true);
        }
        window.open(props.myAccountLink, '_blank');
    };

    const openCRALink = () => {
        if (props.lang.toUpperCase() === 'EN') {
            window.open(AuthorizeCRAMyAccount_EN);
        } else {
            window.open(AuthorizeCRAMyAccount_FR);
        }
    };

    const onCheckboxClick = () => {
        setChecked((prev) => !prev);
    }

    const onCopyContentClick = () => {
        setCopyText('Authorize.MyAccount.Copied');
        setCopyClicked(true);
        setTimeout(() => {
            // setCopyText('Authorize.MyAccount.Copy');
            setCopyClicked(false);
        }, 1500);
        if (props.craBusinessNumber) {
            navigator.clipboard.writeText(props.craBusinessNumber)
        }
    }

    if (props.craBusinessNumber == null) {
        return (
            <div className="authorizeMyAccountContainerStyle">
                <div className="authorizeContentStyle">
                    <LoadingSpinner />
                </div>
            </div>
        );
    }

    return (
        <div className='authorizeMyAccountContainerStyle'>
            <div className='authorizeMyAccountCRAInstructionsWrapper'>
                <div className='authorizeMyAccountCRATitle'>{T.translate('Authorize.MyAccount.Title', { FirstName: props.firstName })}</div>
                <div className='authorizeMyAccountCRASubTitle'>{T.translate('Authorize.MyAccount.SubTitle')}</div>
                <div className='authorizeMyAccountCRAProgressContainer'>
                    <div className='authorizeMyAccountCRAProgressStep'>
                        <div className="authorizeMyAccountCRAProgressCircleWrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <circle cx="16" cy="16" r="15" stroke="#007500" strokeWidth="2"/>
                                <text x="12" y="22" fill="#000" fontFamily="Roboto" fontSize="16" fontWeight="500">1</text>
                            </svg>
                            <div className='authorizeMyAccountCRAProgressLine'></div>
                        </div>
                        <div className='authorizeMyAccountCRAProgressStepsText authorizeLinkDisplay SingleLineText'>
                            <div>{T.translate('Authorize.MyAccount.Step1')}</div>
                            <div>
                                <a className='authorizeLinkStyle authorizeLinkDisplay' onClick={onLinkClick}>
                                    <div className='authorizeLinkSpacing'>{T.translate('Authorize.MyAccount.Step1Link')}</div>
                                    <div><img src={OpenLinkInNewTabIcon} /></div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='authorizeMyAccountCRAProgressStep'>
                        <div className="authorizeMyAccountCRAProgressCircleWrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <circle cx="16" cy="16" r="15" stroke="#007500" strokeWidth="2"/>
                                <text x="12" y="22" fill="#000" fontFamily="Roboto" fontSize="16" fontWeight="500">2</text>
                            </svg>
                            <div className='authorizeMyAccountCRAProgressLine'></div>
                        </div>
                        <div className='authorizeMyAccountCRAProgressStepsText'>
                            {T.translate('Authorize.MyAccount.Step2')}
                        </div>
                    </div>
                    <div className='authorizeMyAccountCRAProgressStep'>
                        <div className="authorizeMyAccountCRAProgressCircleWrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <circle cx="16" cy="16" r="15" stroke="#007500" strokeWidth="2"/>
                                <text x="12" y="22" fill="#000" fontFamily="Roboto" fontSize="16" fontWeight="500">3</text>
                            </svg>
                            <div className='authorizeMyAccountCRAProgressLine'></div>
                        </div>
                        <div className='authorizeMyAccountCRAProgressStepsText'>
                            {T.translate('Authorize.MyAccount.Step3')}
                            <div>
                                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '16px', tableLayout: 'fixed' }}>
                                    <colgroup>
                                        <col style={{ width: '35%' }} />
                                        <col style={{ width: '65%' }} />
                                    </colgroup>
                                    <tbody>
                                        <tr style={{ borderBottom: '2px solid #D2D2D2' }}>
                                        <td style={{ padding: '8px 8px' }}>{T.translate('Authorize.MyAccount.InfoTitle1')}</td>
                                        <td colSpan={2} style={{ padding: '8px 8px' }}>
                                            <div
                                                className="copyWrapper"
                                                onMouseEnter={() => {
                                                    if (props.layoutType === 'desktop') setHoverCopy(true);
                                                }}
                                                onMouseLeave={() => {
                                                    if (props.layoutType === 'desktop') setHoverCopy(false);
                                                }}
                                            >
                                                {(copyClicked || (hoverCopy && props.layoutType === 'desktop')) ? (
                                                    <div className="copyToClipboardWrapper">
                                                        <div className="copyToClipboard">
                                                            {T.translate(copyClicked ? copyText : 'Authorize.MyAccount.Copy')}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="copyToClipboardWrapper">
                                                        <div className="copyToClipboardHidden">
                                                            {T.translate('Authorize.MyAccount.Copy')}
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="authorizeMyAccountCRAProgressStepsTextCopyContent" onClick={onCopyContentClick}>
                                                    <img className="copyContentIcon" src={CopyContentIcon} alt="" />
                                                    <div className="copyContentText">
                                                        {T.translate('Authorize.MyAccount.InfoTitle1b', { businessNumber: props.craBusinessNumber })}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className='authorizeMyAccountCRAProgressStep'>
                        <div className="authorizeMyAccountCRAProgressCircleWrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <circle cx="16" cy="16" r="15" stroke="#007500" strokeWidth="2"/>
                                <text x="12" y="22" fill="#000" fontFamily="Roboto" fontSize="16" fontWeight="500">4</text>
                            </svg>
                            <div className='authorizeMyAccountCRAProgressLine'></div>
                        </div>
                        <div className='authorizeMyAccountCRAProgressStepsText SingleLineText'>
                            {T.translate('Authorize.MyAccount.Step4')}
                            <div>
                                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '16px', marginBottom: '24px', tableLayout: 'fixed' }}>
                                    <colgroup>
                                        <col style={{ width: '40%' }} />
                                        <col style={{ width: '60%' }} />
                                    </colgroup>
                                    <tbody>
                                        <tr style={{ borderBottom: '2px solid #D2D2D2' }}>
                                        <td style={{ padding: '8px 8px' }}>{T.translate('Authorize.MyAccount.InfoTitle2')}</td>
                                        <td style={{ padding: '8px 8px' }}>{T.translate('Authorize.MyAccount.InfoTitle2b', { businessName: props.craBusinessName })}</td>
                                        </tr>
                                        <tr style={{ borderBottom: '2px solid #D2D2D2' }}>
                                        <td style={{ padding: '8px 8px' }}>{T.translate('Authorize.MyAccount.InfoTitle3')}</td>
                                        <td style={{ padding: '8px 8px' }}>{T.translate('Authorize.MyAccount.InfoTitle3b')}</td>
                                        </tr>
                                        <tr style={{ borderBottom: '2px solid #D2D2D2' }}>
                                        <td style={{ padding: '8px 8px' }}>{T.translate('Authorize.MyAccount.InfoTitle4')}</td>
                                        <td style={{ padding: '8px 8px' }}>{T.translate('Authorize.MyAccount.InfoTitle4b')}</td>
                                        </tr>
                                        <tr style={{ borderBottom: '2px solid #D2D2D2' }}>
                                        <td style={{ padding: '8px 8px' }}>{T.translate('Authorize.MyAccount.InfoTitle5')}</td>
                                        <td style={{ padding: '8px 8px' }}>{T.translate('Authorize.MyAccount.InfoTitle5b')}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className='authorizeMyAccountCRAProgressStep'>
                        <div className="authorizeMyAccountCRAProgressCircleWrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <circle cx="16" cy="16" r="15" stroke="#007500" strokeWidth="2"/>
                                <text x="12" y="22" fill="#000" fontFamily="Roboto" fontSize="16" fontWeight="500">5</text>
                            </svg>
                            <div className='authorizeMyAccountCRAProgressLine'></div>
                        </div>
                        <div className='authorizeMyAccountCRAProgressStepsText SingleLineText authorizeMyAccountCRAProgressLastStep' onClick={onCheckboxClick}>
                            <div className='authorizeMyAccountCRAProgressStepsTextCheckbox'>
                                { !checked ? 
                                    (<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                        <path d="M22.1667 5.83333V22.1667H5.83333V5.83333H22.1667ZM22.1667 3.5H5.83333C4.55 3.5 3.5 4.55 3.5 5.83333V22.1667C3.5 23.45 4.55 24.5 5.83333 24.5H22.1667C23.45 24.5 24.5 23.45 24.5 22.1667V5.83333C24.5 4.55 23.45 3.5 22.1667 3.5Z" fill="black" fill-opacity="0.6"/>
                                    </svg>) 
                                    :
                                    (<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                        <path d="M22.1667 3.5H5.83333C4.53833 3.5 3.5 4.55 3.5 5.83333V22.1667C3.5 23.45 4.53833 24.5 5.83333 24.5H22.1667C23.4617 24.5 24.5 23.45 24.5 22.1667V5.83333C24.5 4.55 23.4617 3.5 22.1667 3.5ZM11.6667 19.8333L5.83333 14L7.47833 12.355L11.6667 16.5317L20.5217 7.67667L22.1667 9.33333L11.6667 19.8333Z" fill="#2E7D32"/>
                                    </svg>)
                                }
                            </div>
                            <div className='authorizeMyAccountCRAProgressStepsTextCheckboxDescrption'>
                                {T.translate('Authorize.MyAccount.Step5')}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='authorizeMyAccountCRAInstructionsWarning'>
                    {T.translate('Authorize.MyAccount.InfoMore')}
                    <a className='authorizeLinkStyle' onClick={openCRALink} rel="noopener noreferrer" download>
                        {T.translate('Authorize.MyAccount.InfoMoreDoc')} 
                    </a>
                </div>
                <div className='authorizeMyAccountCRAInstructionsWarning'>
                    {T.translate('Authorize.MyAccount.Warning1.MyAccountCRA')}
                    <a className='authorizeLinkStyle' onClick={jumpToMessage}>
                        {T.translate('Authorize.MyAccount.Warning2.MyAccountCRA')}
                    </a>
                </div>
            </div>
        </div>
    );
};

AuthorizeMyAccountCRA.propTypes = {
    lang: PropTypes.string.isRequired,
    layoutType: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    isSpouse: PropTypes.bool.isRequired,
    province: PropTypes.string.isRequired,
    craGroupId: PropTypes.string,
    craRepName: PropTypes.string,
    craBusinessNumber: PropTypes.string,
    craBusinessName: PropTypes.string,
    myAccountLink: PropTypes.string,
    loadAuthorizationConfig: PropTypes.func.isRequired
};

export default connect()(AuthorizeMyAccountCRA);